import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './css/tabs.css';
import hotelcss from './css/hotelhotellist.module.css';

import { sendemployeedata, getemployees } from "../dbconnector/connector";
import { useEffect } from 'react';

import { setErrorMessage, setMessage, clearMessage, setHTMLMessage } from "../tools/errorhandling";
import Button from 'react-bootstrap/Button';

import EmployeeNode from '../customNodes/EmployeeNode';
import moment, { now } from "moment";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';


const createlist = (t, list, navigate) => {
    let divlist = document.getElementById("list")
    if (divlist === null) {
        let divlistheader = document.getElementById("resultlistHeader")
        const upperdiv = document.getElementById("searchbox");//resultlist
        const resultdiv = document.getElementById("resultlist")
        const newuserdiv = document.getElementById("newuser")

        divlist = document.createElement("div");
        divlist.id = "list"

        const zoekbalk = document.createElement("input");
        zoekbalk.type = "text"
        zoekbalk.id = "Zoekbalk"
        zoekbalk.placeholder = "Search"

        if (sessionStorage.getItem('employeeZoek') !== null) {
            zoekbalk.value = sessionStorage.getItem('employeeZoek')
        }

        const activelabel = document.createElement("label");
        activelabel.id = "activelabel"
        activelabel.className = "labelcolor"
        activelabel.innerText = t('Active')


        const active = document.createElement("input");
        active.type = "checkbox"
        active.className = "checkbox"
        if (sessionStorage.getItem('employeeActive') !== null && sessionStorage.getItem('employeeActive').toString() === "false") {
            active.checked = false
        } else {
            active.checked = true
        }
        active.label = "checkbox"

        if (sessionStorage.getItem('employeeShowAll') !== null && sessionStorage.getItem('employeeShowAll').toString() === "false") {
            active.disabled = false
        } else {
            active.disabled = true
        }

        active.id = "active"

        const ShowAlllabel = document.createElement("label");
        ShowAlllabel.id = "activelabel"
        ShowAlllabel.className = "labelcolor"
        ShowAlllabel.innerText = t('ShowAll')


        const showall = document.createElement("input");
        showall.type = "checkbox"
        showall.className = "checkbox"
        showall.id = "showall"
        if (sessionStorage.getItem('employeeShowAll') !== null && sessionStorage.getItem('employeeShowAll').toString() === "false") {
            showall.checked = false
        } else if (sessionStorage.getItem('employeeShowAll') !== null && sessionStorage.getItem('employeeShowAll').toString() === "true") {
            showall.checked = true
        } else { showall.checked = false }


        const addbutton = document.createElement("a");
        addbutton.id = "addbutton";
        addbutton.className = "btn btn-primary";
        addbutton.href = "/create-employee";
        addbutton.innerText = t('Nieuwemedewerker')

        active.addEventListener("click", function (e) {
            const zoekbalk = document.getElementById("Zoekbalk")
            sessionStorage.setItem('employeeActive', active.checked)
            const filteredlist = list.filter(element => {
                if ((element.voornaam + " " + element.achternaam).toLowerCase().includes(zoekbalk.value.toLowerCase()) || element.rijksregisternummer.includes(zoekbalk.value.toLowerCase())) {
                    return element
                }
            })
            createlist(t, filteredlist, navigate)
        })

        showall.addEventListener("click", function (e) {
            active.disabled = showall.checked;
            sessionStorage.setItem('employeeShowAll', showall.checked)
            const zoekbalk = document.getElementById("Zoekbalk")

            const filteredlist = list.filter(element => {
                if ((element.voornaam + " " + element.achternaam).toLowerCase().includes(zoekbalk.value.toLowerCase()) || element.rijksregisternummer.includes(zoekbalk.value.toLowerCase())) {
                    return element
                }
            })
            createlist(t, filteredlist, navigate)
        })

        zoekbalk.addEventListener("input", function (e) {
            if (sessionStorage.getItem('selectedemployee') !== null)
                sessionStorage.removeItem('selectedemployee')
            sessionStorage.setItem('employeeZoek', e.target.value)

            const filteredlist = list.filter(element => {
                if ((element.voornaam + " " + element.achternaam).toLowerCase().includes(e.target.value.toLowerCase()) || element.rijksregisternummer.includes(e.target.value.toLowerCase())) {
                    return element
                }
            })
            createlist(t, filteredlist, navigate)
        })
        upperdiv.appendChild(zoekbalk);
        upperdiv.appendChild(activelabel);
        upperdiv.appendChild(active);
        upperdiv.appendChild(ShowAlllabel);
        upperdiv.appendChild(showall);
        newuserdiv.appendChild(addbutton);
        resultdiv.appendChild(divlist);
    } else {
        divlist.innerHTML = "";
    }

    buildtable(list, divlist, navigate, t)
    
    try {
        if (sessionStorage.getItem('selectedemployee') !== null && document.getElementById("selector_" + sessionStorage.getItem('selectedemployee')) !== null) {
            document.getElementById("selector_" + sessionStorage.getItem('selectedemployee')).focus()
            document.getElementById("selector_" + sessionStorage.getItem('selectedemployee')).disabled = true;
        }
    }
    catch { }
}

const buildtable = (list, divlist, navigate, t) => {
    let filteredlist = list;

    if (sessionStorage.getItem('employeeZoek') !== null) {
        filteredlist = list.filter(element => {
            if ((element.voornaam + " " + element.achternaam).toLowerCase().includes(sessionStorage.getItem('employeeZoek').toLowerCase()) || element.rijksregisternummer.includes(sessionStorage.getItem('employeeZoek').toLowerCase())) {
                return element
            }
        })
    }
    if (document.getElementById("showall").checked === false) {
        filteredlist.filter(element => !document.getElementById("active").checked ? element.actief === 0 : element.actief === 1).forEach((element, index) => {
            addlinetogrid(divlist, element, index, navigate, t)
        });
    } else {
        filteredlist.forEach((element, index) => {
            addlinetogrid(divlist, element, index, navigate, t)
        });

    }
}

const addlinetogrid = (divlist, element, index, navigate, t) => {
    const employediv = document.createElement("div")
    divlist.appendChild(employediv)

    const selector = document.createElement("input");
    selector.className = "smallselector";
    selector.id = "selector_" + element.id

    const EMP_ID_div = document.createElement("p")
    EMP_ID_div.innerText = element.nr_wkn
    employediv.appendChild(EMP_ID_div)

    const name = document.createElement("p")
    employediv.appendChild(name)
    name.innerText = element.voornaam + " " + element.achternaam

    const phone = document.createElement("p")
    phone.innerText = element.gsm
    employediv.appendChild(phone)

    const active = document.createElement("p")
    if (element.actief === 0) {
        active.innerText = "false"
    } else {
        active.innerText = "true"

    }

    employediv.appendChild(active)


    if (sessionStorage.getItem('selectedemployee') === element.id.toString()) {
        employediv.className += hotelcss.hotelselectedRow
        employediv.appendChild(selector);
    } else {
        if (index % 2 === 0) {
            employediv.className = hotelcss.linkVarient1 //"linkVarient1 gridEmployees"
        } else {
            employediv.className = hotelcss.linkVarient2
        }
    }
    employediv.addEventListener('click', function (e) {
        sessionStorage.setItem('selectedemployee', element.id)
        navigate("/employee/" + element.id);
    });
}

const ConstructEmployeePage = (props) => {
    const [employeelist, setEmployeelist] = useState('');
    const navigate = useNavigate();
    const t = props.translation
    useEffect(() => {
        try {
            const employees = getemployees();
            employees.then((result) => {
                if (result.status === 200) {
                    setEmployeelist(result)
                    createlist(props.translation, result.items, navigate)
                } else {
                    setErrorMessage(result.status + ": " + result.message)
                }

            })
        } catch (error) {
            setErrorMessage(t("error_canotgetuserlist"))
        }
    }, []);
    return (
        <div id="main">
            <header>
                <div id="errordiv" className='error'>
                </div>
                <div className="checkinTime">
                    <div id="timelabel" >
                    </div>
                    <div id="time">
                    </div>
                </div>
            </header>
            <div id="newuser" className="form">
            </div>
            <div id="filters" className="form" >
                <label className='formtitleContentBox'>{t('filterinstellingen')}</label>
                <br></br>
                <div className="contentbox ">
                    <div id="searchbox" className="formElement">
                        <label className='labelcolor'>
                            {t('Medewerker')}:
                        </label>
                    </div>
                </div>
                <div id="headertable" className={hotelcss.tableheader}><p id="ID">{t('ID')}</p><p id="Fullname">{t('Name')}</p><p id="Phone">{t('Phone')}</p><p id="active">{t('Active')}</p></div>
                <div id="resultlist" className='list'>
                </div>
            </div>
        </div>
    )
}

const Addemployee = (props) => {
    const t = props.translation
    const [user, setUser] = useState({});
    const navigate = useNavigate()
    const [tabsDisabled, setTabsDisabled] = useState(false);


    useEffect(() => {
        createEmptyuser()
        document.getElementById("editDiv").style.display = "none";
        setTabsDisabled(true);
    }, []);

    function formatDateToYYYYMMDD(date) {

        if (date !== null) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure 2-digit month
            const day = String(date.getDate()).padStart(2, '0'); // Ensure 2-digit day

            return `${year}-${month}-${day}`;
        }
        else {
            return null
        }
    }
    const createEmptyuser = () => {
        setUser((prev) => {
            return {
                ...prev,
                actief: 1,
                contractlooptijd:2,
                contracttype:1,
                contracturen:36.50,
                employer:-1
            }
        })
        // await setUser({
        //         actief:1,
        //         contractlooptijd:2,
        //         contracttype:3,
        //         contracturen:"36.50"
        //     });

    }

    const changedate = (e, datefield) => {
        setUser((prev) => {
            return {
                ...prev,
                [datefield]: formatDateToYYYYMMDD(e)
            }
        })
    }

    const changevalue = (e) => {
        setUser((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.value
            }
        })
    }

    const changecheckbox = (e) => {
        setUser((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.checked
            }
        })
    }

    const setcontracttypevalue = (e) => {
        setUser((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.value
            }
        })
    }

    const setcontractlooptijdvalue = (e) => {
        setUser((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.value
            }

        })
        if (e.target.value === 1) {
            document.getElementById("InService").style.display = "none";
        } else {
            document.getElementById("InService").style.display = "block";
        }
        if (e.target.id === "contractlooptijd_2") {
            document.getElementById("OutService").style.display = "block";
        }
        if (e.target.id === "contractlooptijd_3") {
            document.getElementById("OutService").style.display = "block";
        }
        if (e.target.id === "contractlooptijd_1") {
            document.getElementById("OutService").style.display = "none";
        }

    }
    const onSubmit = (e) => {
        ////console.log("onsubmit employee.js")
        ////console.log("onsubmit employee.js user :", user)
        e.preventDefault();
        let mandatoryfieldsmissing = ""
        if (user.idnummer === undefined) {
            mandatoryfieldsmissing = mandatoryfieldsmissing + "<li>"+ t('ID-nummer')+"</li>"
        }
        if (user.functie === undefined) {
            mandatoryfieldsmissing = mandatoryfieldsmissing + "<li>"+ t('functie')+"</li>"
        }
        if (user.ingangsdatum_id === undefined) {
            mandatoryfieldsmissing = mandatoryfieldsmissing + "<li>"+ t('ingangsdatum')+"</li>"
        }
        if (user.nr_wkn === undefined) {
            mandatoryfieldsmissing = mandatoryfieldsmissing + "<li>"+ t('nr_wkn')+"</li>"
        }
        if (user.voornaam === undefined) {
            mandatoryfieldsmissing = mandatoryfieldsmissing + "<li>"+ t('voornaam')+"</li>"
        }
        if (user.geslacht === undefined) {
            mandatoryfieldsmissing = mandatoryfieldsmissing + "<li>"+ t('geslacht')+"</li>"
        }
        if (user.contracttype === undefined) {
            mandatoryfieldsmissing = mandatoryfieldsmissing + "<li>"+ t('contracttype')+"</li>"
        }
        if (user.contracturen === undefined) {
            mandatoryfieldsmissing = mandatoryfieldsmissing + "<li>"+ t('contracturen')+"</li>"
        }
        if (user.contractlooptijd === undefined) {
            mandatoryfieldsmissing = mandatoryfieldsmissing + "<li>"+ t('contractlooptijd')+"</li>"
        }
        if (user.FK_Rechten_ID === undefined) {
            mandatoryfieldsmissing = mandatoryfieldsmissing + "<li>"+ t('profiel')+"</li>"
        }
        if (mandatoryfieldsmissing !== "") {
           setHTMLMessage(t("fieldsMissing_1") + mandatoryfieldsmissing + t("fieldsMissing_2"))
        } else {
            const response = sendemployeedata(user);
            response.then((res) => {
                //////console.log(res)
                if (res.status === 200) {
                    setTabsDisabled(false);
                    navigate('/employees');
                } else {

                    setMessage(res.statusText)
                }

            })
        }
    }
     
    const navigateback = () => {
        navigate('/employees')
    }

    return (
        <div id="main">
            <header><div id="errordiv" className='error'></div><div className="checkinTime"><div id="timelabel" ></div><div id="time"></div></div></header>
            <div id="coverAllmessage" className="coverall">
                <div id="messagediv" className='message'>
                    <div id="messagetext" className="MessageText">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean at justo eu risus molestie egestas a rhoncus tellus.
                        Mauris laoreet, dolor at molestie facilisis, metus lorem ornare felis, nec porta sem nulla id dolor. </div>
                    <br></br>
                    <center><Button type="button" id="cancelButton" className="OkCancel" onClick={clearMessage}>{t("OK")}</Button></center>
                </div>
            </div>
            <div id="return" className="form">
                <Button type="button" id="cancelButton" class="Savebutton btn btn-primary margin-right" onClick={navigateback}>{t('Naaroverzicht')}</Button>
            </div>
            <EmployeeNode
                rights={props.rights}
                translation={props.translation}
                isDisabled={false}
                hotelsarray="null"
                data={{ user: user }}
                events={{ changedate: changedate, changecheckbox: changecheckbox, changevalue: changevalue, handleEdit: null, handleCancel: navigateback, setContract: null, openContract: null, setcontractlooptijdvalue: setcontractlooptijdvalue, setcontracttypevalue: setcontracttypevalue, navigateback: navigateback, onSubmit: onSubmit }}
                displaytabs={{ tab1: true, tab2: true, tab3: true, tab4: true, tab5: true, tab6: true }}
                disabledtabs={{ tab1: false, tab2: false, tab3: false, tab4: false, tab5: true, tab6: true }}
                defaulttab="0"
                viewOnly={false}
            />

        </div>
    )
}
export { ConstructEmployeePage, Addemployee }